const weekdays = [
  { value: 1, label: "Lun" }, { value: 2, label: "Mar" }, { value: 3, label: "Mié" }, { value: 4, label: "Jue" },
  { value: 5, label: "Vie" }, { value: 6, label: "Sáb" }, { value: 0, label: "Dom" },
];

export function WeekdayPicker({ value, onChange }: { value: number[]; onChange: (days: number[]) => void }) {
  const toggle = (day: number) => onChange(value.includes(day) ? value.filter((item) => item !== day) : [...value, day].sort((a, b) => a - b));
  return <fieldset className="weekday-picker"><legend>Días habilitados</legend>{weekdays.map((day) => <button key={day.value} type="button" aria-pressed={value.includes(day.value)} className={value.includes(day.value) ? "selected" : ""} onClick={() => toggle(day.value)}>{day.label}</button>)}</fieldset>;
}

export function weekdayNames(value: number[]) {
  return weekdays.filter((day) => value.includes(day.value)).map((day) => day.label).join(", ") || "Ningún día";
}
